// extracted by mini-css-extract-plugin
export default {"wp_content":"careerPost_wp_content__dcuDS"};